import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stories-header',
  templateUrl: './stories-header.component.html',
  styleUrls: ['./stories-header.component.css']
})
export class StoriesHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
